export default {
  'folding_of_foot_siderails': {
    cs: 'Středová postranice dolů',
    en: 'Folding of Foot Siderails',
    track: 'foot_siderails'
  },
  'folding_of_head_siderails': {
    cs: 'Hlavová postranice dolů',
    en: 'Folding of Head Siderails',
    track: 'head_siderails'
  },
  'mobilift': {
    cs: 'Mobi-Lift',
    en: 'Mobi-Lift',
    track: 'mobilift_l',
  },
  'mobilift_r': {
    cs: 'Mobi-Lift',
    en: 'Mobi-Lift',
    track: 'mobilift_r',
  },
  'trendelenburg': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg',
  },
  'reversetrendelenburg': {
    cs: 'Reverzní Trendelenburg',
    en: 'Reverse Trendelenburg',
    track: 'reversetrendelenburg_from_max',
  },
  'cardiac_chair': {
    cs: 'Kardiacké křeslo',
    en: 'Cardiac Chair'
  },
  'mobilization_position': {
    cs: 'Mobilizační pozice',
    en: 'Mobilization Position'
  },

  'cpr': {
    cs: 'CPR',
    en: 'CPR',
    track: null
  },

  'bed_height_adjustment_up': {
    cs: 'Zvedání ložné plochy',
    en: 'Bed Height Adjustment Up',
    track: 'max_to_min'
  },
  'bed_height_adjustment_down': {
    cs: 'Zvedání ložné plochy',
    en: 'Bed Height Adjustment Down',
    track: 'max_to_min'
  },
  'backrest_adjustment_up': {
    cs: 'Zvedání zádového dílu',
    en: 'Backrest Adjustment Up',
    track: 'backrest_adjustment'
  },
  'backrest_adjustment_down': {
    cs: 'Sklápění zádového dílu',
    en: 'Backrest Adjustment Down',
    track: 'backrest_adjustment'
  },
  'thighrest_adjustment_up': {
    cs: 'Zvedání stehen',
    en: 'Thighrest Adjustment Up',
    track: 'thighrest_adjustment'
  },
  'thighrest_adjustment_down': {
    cs: 'Sklápění stehen',
    en: 'Thighrest Adjustment Down',
    track: 'thighrest_adjustment'
  },
  'autocontour_up': {
    cs: 'Autokontura nahoru',
    en: 'Autocontour Up'
  },
  'autocontour_down': {
    cs: 'Autokontura dolů',
    en: 'Autocontour Down'
  },

  'striska': {
    track: 'striska'
  },
  'nohy_rovina': {
    track: 'nohy_rovina'
  },

  // PRECHODY
  'max_to_min': {
    track: 'max_to_min',
    transitions: {
      'mobilization_position': 'mobilization_position_from_min'
    }
  },
  'max_to_mid': {
    track: 'max_to_mid',
    transitions: {
      'mobilization_position': 'mobilization_position_from_mid'
    }
  },
  'mid_to_min': {
    track: 'mid_to_min'
  },
  'min_to_max': {
    track: 'min_to_max'
  },

  'reversetrendelenburg_to_min': {
    track: 'reversetrendelenburg_to_min'
  },
  'min_to_reversetrendelenburg': {
    track: 'min_to_reversetrendelenburg'
  },
  'trendelenburg_to_min': {
    track: 'trendelenburg_to_min'
  },
  'min_to_trendelenburg': {
    track: 'min_to_trendelenburg'
  },
  'mid_to_reversetrendelenburg': {
    track: 'mid_to_reversetrendelenburg'
  },
  'mid_to_trendelenburg': {
    track: 'mid_to_trendelenburg'
  },

  'trendelenburg_to_reverse_trendelenburg': {
    track: 'trendelenburg_to_reverse_trendelenburg'
  },
  'trendelenburg_backrest_adjustment_30': {
    track: 'trendelenburg_backrest_adjustment_30',
    reversed: true
  },
  'trendelenburg_backrest_adjustment_45': {
    track: 'trendelenburg_backrest_adjustment_45',
    reversed: true
  },
  'trendelenburg_backrest_adjustment_70': {
    track: 'trendelenburg_backrest_adjustment_70',
    reversed: true
  },

  'reversetrendelenburg_backrest_adjustment_30': {
    track: 'reversetrendelenburg_backrest_adjustment_30',
    reversed: true
  },
  'reversetrendelenburg_backrest_adjustment_45': {
    track: 'reversetrendelenburg_backrest_adjustment_45',
    reversed: true
  },
  'reversetrendelenburg_backrest_adjustment_70': {
    track: 'reversetrendelenburg_backrest_adjustment_70',
    reversed: true
  },

  'lateral_l': {
    cs: 'Laterální náklon vlevo',
    en: 'Lateral Tilt Left',
    track: 'lateral_l'
  },
  'lateral_r': {
    cs: 'Laterální náklon vpravo',
    en: 'Lateral Tilt Right',
    track: 'lateral_r'
  }
}